module.exports = __webpack_public_path__ + "static/media/morph.af4f8e40.svg";